/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/class/KavenCollection.ts
 * @create:      2020-01-20 10:41:34.963
 * @modify:      2025-07-03 10:57:42.622
 * @version:     6.0.0
 * @times:       29
 * @lines:       84
 * @copyright:   Copyright © 2020-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { IKavenCollection } from "../interface/IKavenCollection";
import { DeleteKeyValuePair } from "../core/KeyValuePair";
import { FindKeyValuePair } from "../core/KeyValuePair";
import { TStringObject } from "../type/basic";

export class KavenCollection<T> implements IKavenCollection<T> {
    private readonly items: TStringObject<T> = {};

    public constructor(str?: string) {
        if (str) {
            this.items = JSON.parse(str);
        }
    }

    public ContainsKey(key: string, ignoreCase = false): boolean {
        return FindKeyValuePair(this.items, key, ignoreCase) !== undefined;
    }

    public get Count() {
        return this.Keys().length;
    }

    public Add(key: string, value: T) {
        this.items[key] = value;
    }

    public Remove(key: string, ignoreCase = false) {
        const r = DeleteKeyValuePair(this.items, key, ignoreCase);
        return r?.value;
    }

    public GetValue(key: string, defaultValue?: T): T | undefined {
        return this.ContainsKey(key) ? this.items[key] : defaultValue;
    }

    public Keys(): string[] {
        return Object.keys(this.items);
    }

    public Values(): T[] {
        return Object.values(this.items);
    }

    public Items() {
        return Object.entries(this.items);
    }

    public ToString(space?: string | number, replacer?: (number | string)[] | null) {
        return JSON.stringify(this.items, replacer, space);
    }
}
